import {eventBus} from "@/Services/eventBus.js"

// colors = primary, secondary, success, info, warning, error
export const helpers = {
    toast(message, type = 'success', options = {}) {
        eventBus.emit('emitToast', {
            message,
            type,
            options
        })
    },
    formatPrice(price) {
        if(!price)
            return null

        return Number(price).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },
    firstLetterUppercase(word) {
        if (!word)
            return ''

        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    }
}

